import styled, { css } from 'styled-components/macro'
import media from 'styled-media-query'
import { Stars } from '@styled-icons/material-rounded'
import { Box, Button } from '@material-ui/core'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 36px 32px 86px;
`

export const WrapperFixed = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
`

export const Cabecalho = styled.div`
  display: grid;
  grid-template:
    'Voltar Voltar'
    'Terreno Terreno'
    'DataSimulacao EncolherTudo';
  padding-bottom: 16px;
  align-items: center;
  z-index: 1;
`
export const Principal = styled.main`
  padding: 56px 112px 48px 112px;

  ${media.lessThan('medium')`
    padding: 24px 0 0 0;
  `}

  ${media.between('medium', 'large')`
    padding: 56px 24px 24px 24px;
  `}

  ${media.greaterThan('huge')`
    padding: 56px 320px 48px 320px;
  `}
`

export const Voltar = styled.div`
  grid-area: Voltar;
  margin-bottom: 18px;
`
export const Terreno = styled.div`
  grid-area: Terreno;
`
export const DataSimulacaoEncolherTudo = styled.div`
  ${({ theme }) => css`
    font-size: ${theme.font.sizes.small};
    color: ${theme.colors.gray};
  `}
`
export const DataSimulacao = styled(DataSimulacaoEncolherTudo)`
  grid-area: DataSimulacao;
  justify-self: start;
`
export const Rodape = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.colors.secondary};
  `}
  width: 100%;
  height: 72px;
  position: fixed;
  bottom: 0;
  left: 0;
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  grid-gap: 20px;
  padding: 0 16px;
  ${media.greaterThan('medium')`
    justify-content: flex-end;
    padding: 0 32px;
  `}
`

export const CartoesWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
  gap: 32px;
  padding: 0 112px 48px 112px;

  ${media.lessThan('medium')`
    flex-direction: column;
    padding: 0;
  `}

  ${media.between('medium', 'large')`
    padding: 0 24px 24px 24px;
  `}

  ${media.greaterThan('huge')`
    padding: 0 320px 48px 320px;
  `}
`

export const ColunaCartoes = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  flex: 1;
  gap: 32px;
  justify-content: space-between;
`

export const BoxCustomizada = styled(Box)`
  display: flex;
  gap: 18px;
  justify-content: end;
`

export const IconeVigente = styled(Stars)`
  ${({ theme }) => css`
    color: ${theme.colors.secondary} !important;
  `}
`

export const BotaoVigente = styled(Button)`
  ${({ theme }) => css`
    border: solid 1px ${theme.colors.primary3} !important;
    color: ${theme.colors.secondary} !important;

    &:disabled {
      background-color: ${theme.colors.primary} !important;
      color: ${theme.colors.white} !important;
      border: solid 1px ${theme.colors.primary} !important;
      ${IconeVigente} {
        color: ${theme.colors.white} !important;
      }
    }
  `}
`

export const TextoModalTornarVigente = styled.span`
  margin-top: 20px;
  text-align: center;
  line-height: 22px;
  ${({ theme }) => css`
    color: ${theme.colors.black};
  `}
`
